import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../data/translations';

const COOKIE_KEY = 'cobras_cookie_consent';

const CookieConsent = () => {
  const { lang } = useLanguage();
  const { t, get } = useTranslation(lang);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_KEY, 'necessary');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] p-4 md:p-6"
      style={{ animation: 'slideUp 0.4s ease-out' }}
    >
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
      <div
        className="max-w-4xl mx-auto rounded-sm p-6 md:p-8 border border-gray-800"
        style={{ backgroundColor: '#111', backdropFilter: 'blur(12px)' }}
      >
        <h3 className="text-white font-bold text-lg mb-3">{get(t.cookie.title)}</h3>
        <p className="text-gray-400 text-sm leading-relaxed mb-5">{get(t.cookie.text)}</p>
        <div className="flex flex-wrap gap-3">
          <button
            onClick={handleAccept}
            className="px-6 py-2.5 text-sm font-bold tracking-wider uppercase text-white transition-all duration-300 hover:opacity-90"
            style={{ backgroundColor: '#A855F7' }}
          >
            {get(t.cookie.accept)}
          </button>
          <button
            onClick={handleDecline}
            className="px-6 py-2.5 text-sm font-bold tracking-wider uppercase text-gray-300 border border-gray-600 hover:border-white hover:text-white transition-all duration-300"
          >
            {get(t.cookie.decline)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
